import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  AfterViewInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[qaDynamicHeight]',
  standalone: true,
})
export class DynamicHeightDirective implements OnChanges, AfterViewInit {
  @Input('qaDynamicHeight') trigger: any;
  @Input() childSelector: string;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['trigger']) {
      this.updateHeight();
    }
  }

  ngAfterViewInit(): void {
    this.updateHeight();
  }

  private updateHeight(): void {
    setTimeout(() => {
      const parent = this.el.nativeElement;
      const children = this.childSelector
        ? parent.querySelectorAll(this.childSelector)
        : parent.children;

      let totalHeight = 0;
      children.forEach((child: HTMLElement) => {
        totalHeight += child.offsetHeight;
      });

      this.renderer.setStyle(parent, 'height', `${totalHeight}px`);
    }, 0);
  }
}
